<template>
    <div class="broker-contact-form">
        <div class="text-center">
            <a class="btn btn-dark" data-bs-toggle="modal" data-bs-target="#broker-contact-form-popup">{{ sendRequestLabel }}</a>
        </div>
        <div class="modal fade" id="broker-contact-form-popup" tabindex="-1">
            <div class="modal-dialog modal-md">
                <loading :active.sync="isSubmitting"
                         :is-full-page="false"/>
                <Form @submit="onSubmit">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">{{ sendRequestLabel }}</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="position-relative">
                            <div class="modal-body">
                                <div v-for="field in fields" :key="field.name">
                                    <Field
                                        :type="field.type"
                                        :as="field.as"
                                        :id="field.name"
                                        :name="field.name"
                                        :label="field.label"
                                        :rules="field.rules"
                                        :placeholder="field.label"
                                        :value="field.value"
                                        class="form-control" />
                                    <ErrorMessage :name="field.name" />
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button :disabled="isSubmitting" type="submit" class="btn btn-dark">{{ submitLabel }}</button>
                            </div>

                            <div class="alert" v-if="isSent || hasError.length">
                                <div class="message" v-if="hasError.length">
                                    <font-awesome-icon :icon="['fa', 'times']"/>
                                    <div>
                                        {{hasError}}
                                    </div>
                                </div>
                                <div class="message" v-else>
                                    <font-awesome-icon :icon="['fa', 'check']"/>
                                    <div>
                                        Message sent!
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import {
        Form, Field, ErrorMessage, configure,
    } from 'vee-validate';
    import { localize, setLocale } from '@vee-validate/i18n';
    import en from '@vee-validate/i18n/dist/locale/en.json';
    import de from '@vee-validate/i18n/dist/locale/de.json';
    import ru from '@vee-validate/i18n/dist/locale/ru.json';
    import zhCN from '@vee-validate/i18n/dist/locale/zh_CN.json';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

    configure({
        generateMessage: localize({
            en,
            de,
            ru,
            zhCN,
        }),
    });

    export default {
        name: 'BrokerContactForm',
        components: {
            Form, Field, ErrorMessage, FontAwesomeIcon,
        },
        data() {
            return {
                isSubmitting: false,
                isSent: false,
                hasError: '',
            };
        },
        methods: {
            onSubmit(values, { resetForm }) {
                this.isSubmitting = true;
                this.hasError = '';
                const formData = new FormData();
                Object.keys(values).map((key) => {
                    formData.append(key, values[key]);
                });
                axios.post('/api/contact-broker', formData).then((response) => {
                    // eslint-disable-next-line no-return-assign
                    window.setTimeout(() => this.isSent = true, 1000);
                    resetForm();
                }).catch((error) => {
                    this.hasError = 'Error!';
                }).finally(() => {
                    window.setTimeout(() => {
                        this.isSubmitting = false;
                    }, 1000);
                    window.setTimeout(() => {
                        this.isSent = false;
                    }, 5000);
                });
            },
        },
        mounted() {
            setLocale(this.locale);
        },
        props: {
            sendRequestLabel: {
                type: String,
                required: true,
            },
            submitLabel: {
                type: String,
                required: true,
            },
            fields: {
                type: Array,
                default() {
                    return [];
                },
            },
            locale: {
                type: String,
                default: 'en',
            },
        },
    }
</script>

<style lang="scss">
    @import "~bootstrap/scss/vendor/rfs";
    @import '../../scss/variables';

    .broker-contact-form {
        position: relative;
        textarea {
            border: 2px solid $blue-color;
            border-radius: 10px;
            color: $dark-blue-color;
            height: 8rem;
            &::placeholder {
                color: $blue-color;
            }
            &:focus {
                border-color: $dark-blue-color;
                box-shadow: none;
            }
        }
        span[role="alert"] {
            font-size: small;
            color: $warning-color;
        }
        .alert {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            border: 2px solid $light-blue-color;
            background: #fff;
            border-radius: 6px;
            margin: 0;
            .close {
                position: absolute;
                top: 10px;
                right: 10px;
                color: $light-blue-color;
                @include font-size(20px);
                line-height: 20px;
                &:hover {
                    color: $dark-blue-color;
                }
            }
            .message {
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                height: 100%;
                text-transform: uppercase;
                color: $light-blue-color;
                @include font-size(30px);
                .fa-check, .fa-times {
                    @include font-size(40px);
                }
            }
        }
    }
</style>
